import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { EMPTY, Observable, of, switchMap, take, tap } from 'rxjs';

import { MemberProfile } from '@lib/core/models/member.interface';
import { fetchMemberAppointments, fetchMemberProfile, selectMemberProfile } from '@lib/members/data-access';

export const clientProfileResolver: ResolveFn<MemberProfile> = (route: ActivatedRouteSnapshot): Observable<MemberProfile> => {
  const store = inject(Store);
  const clientId: string = route.paramMap.get('id') || route.paramMap.get('memberId');

  return store.select(selectMemberProfile).pipe(
    switchMap((profile: MemberProfile) => {
      if (!profile || profile.id !== clientId) {
        store.dispatch(fetchMemberProfile({ memberId: clientId }));
        return EMPTY;
      } else return of(profile);
    }),
    tap(profile => {
      store.dispatch(fetchMemberAppointments({ userId: profile.userId }));

      return of(profile);
    }),
    take(1)
  );
};
